export const _ReportsSVG = () => (
  <svg
    viewBox="0 0 160 160"
    width={".5em"}
    height={".5em"}
    display={"flex"}
    fill="currentColor"
  >
    <g>
      <g>
        <path
          class="st1"
          d="M39.8,27.1h49.7c1.3,0,2.3-1,2.3-2.4c0-1.2-1-2.4-2.3-2.4H39.8c-1.3,0-2.3,1.1-2.3,2.4
			C37.5,26,38.5,27.1,39.8,27.1z"
        />
      </g>
      <g>
        <path
          class="st1"
          d="M63.2,42.5c0,1.3,1,2.4,2.3,2.4h49.1c1.3,0,2.4-1,2.4-2.4c0-1.2-1.1-2.3-2.4-2.3H65.5
			C64.2,40.2,63.2,41.2,63.2,42.5z"
        />
      </g>
      <g>
        <path
          class="st1"
          d="M39.8,44.8h13.3c1.3,0,2.3-1,2.3-2.4c0-1.2-1-2.3-2.3-2.3H39.8c-1.3,0-2.3,1-2.3,2.3
			C37.5,43.8,38.5,44.8,39.8,44.8z"
        />
      </g>
      <g>
        <path
          class="st1"
          d="M108.5,58h-24c-1.3,0-2.4,1-2.4,2.4c0,1.3,1.1,2.4,2.4,2.4h24c1.3,0,2.4-1,2.4-2.4
			C110.8,59,109.8,58,108.5,58z"
        />
      </g>
      <g>
        <path
          class="st1"
          d="M39.8,62.7H72c1.3,0,2.4-1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4H39.8c-1.3,0-2.3,1-2.3,2.4
			C37.5,61.6,38.5,62.7,39.8,62.7z"
        />
      </g>
      <g>
        <path
          class="st1"
          d="M95.9,116.1h18.7c1.3,0,2.4-1,2.4-2.4c0-1.3-1.1-2.3-2.4-2.3H95.9c-1.3,0-2.3,1-2.3,2.3
			C93.6,115,94.6,116.1,95.9,116.1z"
        />
      </g>
      <g>
        <path
          class="st1"
          d="M39.8,116.1h43.6c1.3,0,2.4-1,2.4-2.4c0-1.3-1-2.3-2.4-2.3H39.8c-1.3,0-2.3,1-2.3,2.3
			C37.5,115,38.5,116.1,39.8,116.1z"
        />
      </g>
      <g>
        <path
          class="st1"
          d="M39.8,133.8h16.9c1.3,0,2.3-1,2.3-2.3s-1-2.4-2.3-2.4H39.8c-1.3,0-2.3,1-2.3,2.4
			C37.5,132.9,38.5,133.8,39.8,133.8z"
        />
      </g>
      <g>
        <path
          class="st1"
          d="M98.3,129.2H69.2c-1.3,0-2.3,1-2.3,2.4c0,1.3,1,2.3,2.3,2.3h29.1c1.3,0,2.3-1,2.3-2.3
			C100.6,130.2,99.6,129.2,98.3,129.2z"
        />
      </g>
      <g>
        <path
          class="st1"
          d="M150.8,72.7c-0.4-0.7-1.2-1.3-2.1-1.3h-12.1h-3.3V24.7c0-0.1,0-0.1,0-0.1c0-0.2,0-0.4-0.1-0.6
			c0-0.1,0-0.1-0.1-0.2c-0.1-0.2-0.3-0.5-0.5-0.7L110.1,0.6c-0.2-0.2-0.5-0.3-0.7-0.4c-0.1-0.1-0.1-0.1-0.2-0.1
			C109,0,108.8,0,108.6,0h-0.1H23.4c-1.3,0-2.3,1-2.3,2.4v73.8l-19.7,9C0.6,85.6,0,86.4,0,87.3c0,0.9,0.5,1.7,1.4,2.2l19.7,9V152
			c0,1.3,1,2.4,2.3,2.4H131c1.3,0,2.3-1,2.3-2.4v-49h1.1h2.1l0,0l0,0l0,0h12.3c0.9,0,1.7-0.6,2.1-1.3
			C155.6,92.3,155.6,82,150.8,72.7z M32.1,90.9c-0.1,0.7-0.2,1.3-0.4,2c-0.1,0.3-0.2,0.6-0.3,1c-0.2,0.6-0.3,1.2-0.6,1.8
			c-0.1,0.3-0.2,0.7-0.4,1c-0.1,0.2-0.2,0.3-0.2,0.6l-10.4-4.7c1.3-3.6,1.3-7.4,0-11l10.4-4.7c0.1,0.2,0.2,0.3,0.2,0.6
			c0.1,0.3,0.2,0.7,0.4,1c0.2,0.6,0.4,1.2,0.6,1.8c0.1,0.3,0.2,0.7,0.3,1c0.1,0.7,0.3,1.3,0.4,2c0,0.3,0.1,0.6,0.1,0.9
			c0.1,0.9,0.2,1.9,0.2,2.8c0,0.1,0,0.1,0,0.1l0,0c0,1-0.1,1.9-0.2,2.9C32.2,90.4,32.1,90.7,32.1,90.9z M36.9,84.8
			c0-0.3,0-0.6-0.1-1c0-0.3-0.1-0.6-0.1-1c-0.1-0.8-0.3-1.6-0.5-2.4c-0.1-0.3-0.1-0.7-0.2-1c-0.3-1-0.6-1.9-0.9-2.9
			c0-0.1-0.1-0.3-0.1-0.3c0-0.1,0-0.1,0-0.1h100.1c0.1,0.3,0.2,0.6,0.4,0.8c0.2,0.4,0.3,0.8,0.5,1.2c0.2,0.6,0.3,1,0.5,1.6
			c0.1,0.4,0.2,0.8,0.3,1.3s0.2,1,0.3,1.6c0.1,0.4,0.1,0.8,0.2,1.3c0,0.3,0,0.6,0.1,0.8L36.9,84.8L36.9,84.8z M110.8,7.8l7.3,7.3
			l7.3,7.2h-14.6V7.8z M25.8,4.6h80.4v20.1c0,1.3,1,2.4,2.3,2.4h20.2v44.4H31.5c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1
			c-0.2,0-0.5,0.1-0.7,0.1c0,0-0.1,0-0.1,0.1l-4.7,2.1C25.8,73.9,25.8,4.6,25.8,4.6z M15.6,83.6c0.8,2.4,0.8,4.7,0,7l-7.7-3.5
			L15.6,83.6z M128.7,149.5H25.8v-49l4.7,2.2h0.1c0.3,0.1,0.6,0.2,0.9,0.2l0,0l0,0l0,0h97.2V149.5z M134.5,98.1H35c0,0,0,0,0-0.1
			s0.1-0.2,0.1-0.3c0.3-1,0.6-2,0.9-3c0.1-0.3,0.1-0.6,0.2-1c0.2-0.8,0.3-1.6,0.5-2.4c0-0.3,0.1-0.6,0.1-1c0-0.3,0.1-0.6,0.1-0.9
			h100.6v0.1c-0.1,0.6-0.2,1.1-0.3,1.7c-0.1,0.3-0.1,0.8-0.2,1.1c-0.1,0.6-0.3,1.3-0.5,1.9c-0.1,0.3-0.1,0.6-0.3,1
			c-0.3,0.9-0.7,1.9-1.1,2.8L134.5,98.1L134.5,98.1z M147.3,98.1h-7c0,0,0,0,0-0.1s0-0.2,0.1-0.3c0.4-1,0.7-2,0.9-3
			c0.1-0.3,0.2-0.6,0.2-1c0.2-0.8,0.3-1.6,0.4-2.4c0-0.3,0.1-0.6,0.1-1c0.1-1,0.2-2.1,0.2-3.1v-0.1c0-0.1,0-0.1,0-0.1
			c0-1-0.1-2.2-0.2-3.2c0-0.3-0.1-0.6-0.1-1c-0.1-0.8-0.3-1.6-0.4-2.4c-0.1-0.3-0.1-0.7-0.2-1c-0.2-1-0.5-1.9-0.9-2.9
			c0-0.1,0-0.3-0.1-0.3c0-0.1,0-0.1,0-0.1h7C150.5,83.4,150.5,90.9,147.3,98.1z"
        />
      </g>
    </g>
  </svg>
);

export const _ManageTRESVG = () => (
  <svg
    viewBox="0 0 160 160"
    width={".5em"}
    height={".5em"}
    display={"flex"}
    fill="currentColor"
  >
    <g>
      <g>
        <path
          class="st0"
          d="M66.7,31.1c0-8.9-7.2-16.2-16.1-16.2s-16.1,7.3-16.1,16.2s7.2,16.1,16.1,16.1C59.5,47.2,66.7,39.9,66.7,31.1z
			 M50.6,42.6C44.2,42.6,39,37.4,39,31s5.2-11.6,11.6-11.6S62.2,24.6,62.2,31C62.2,37.5,57,42.6,50.6,42.6z"
        />
      </g>
      <g>
        <path
          class="st0"
          d="M134.9,36.2c0.6,0,1.2-0.3,1.6-0.7c0.4-0.4,0.7-1,0.7-1.6c0-0.5-0.3-1.1-0.7-1.6c-0.8-0.8-2.4-0.8-3.2,0
			c-0.4,0.5-0.6,1.1-0.6,1.6c0,0.6,0.3,1.2,0.6,1.6C133.7,36,134.3,36.2,134.9,36.2z"
        />
      </g>
      <g>
        <path
          class="st0"
          d="M126,41.3c0.4,0,0.8-0.1,1.1-0.3c1.1-0.7,1.5-2,0.9-3.1c-0.6-1.1-2-1.5-3.1-0.9c-1.1,0.7-1.4,2-0.8,3.1
			C124.5,40.9,125.2,41.3,126,41.3z"
        />
      </g>
      <g>
        <path
          class="st0"
          d="M117.1,46.4c0.6,0,1.2-0.2,1.6-0.7c0.4-0.4,0.6-0.9,0.6-1.5s-0.2-1.2-0.6-1.6c-0.9-0.9-2.4-0.9-3.2,0
			c-0.4,0.4-0.6,1-0.6,1.6s0.2,1.1,0.6,1.5C115.9,46.2,116.5,46.4,117.1,46.4z"
        />
      </g>
      <g>
        <path
          class="st0"
          d="M148.6,13.4c-0.7-0.4-1.6-0.4-2.3,0L99,40.3L81.3,30.2C81,13.5,67.4,0,50.6,0S20.2,13.5,19.9,30.2L1.1,41
			C0.4,41.4,0,42.1,0,43v103.9c0,0.8,0.4,1.6,1.1,2c0.3,0.2,0.7,0.3,1.1,0.3s0.8-0.1,1.1-0.3L50.6,122l47.3,26.9
			c0.1,0,0.1,0,0.2,0.1c0.1,0,0.1,0,0.2,0.1c0.3,0.1,0.5,0.1,0.8,0.1l0,0l0,0c0.2,0,0.5-0.1,0.8-0.1c0-0.1,0.1-0.1,0.2-0.1
			c0-0.1,0.1-0.1,0.2-0.1l48.4-27.6c0.7-0.4,1.1-1.2,1.1-2V15.4C149.7,14.6,149.3,13.8,148.6,13.4z M50.6,4.6
			c14.5,0,26.2,11.7,26.2,26.2c0,18.4-20.1,46-26.2,54.1c-6.1-8.1-26.2-35.7-26.2-54.1C24.4,16.3,36.2,4.6,50.6,4.6z M52.9,92
			l12.4,7c-3.5,2.6-7.6,4.3-12.4,4.8V92z M54.3,87.6c4.1-5.4,14-18.8,20.6-33.1l10.9,6.3c-1,5.4-5.5,24.3-16.8,35.2L54.3,87.6z
			 M4.5,44.3l15.7-9c0.6,4.8,2.2,9.9,4.3,15L4.4,61.7L4.5,44.3L4.5,44.3z M4.5,67l21.9-12.5C33,68.8,42.9,82.2,47,87.6L4.5,111.8
			C4.5,111.8,4.5,67,4.5,67z M48.4,118l-19.3,11c1.7-6.7,6.6-18.7,19.3-20.3V118z M48.4,104.1c-19.2,1.9-23.7,22.6-24.6,27.7
			l-19.3,11v-25.9l43.9-25V104.1z M96.8,142.9L53,118v-9.6c6.6-0.5,12.2-3.1,16.8-6.7l27.1,15.4v25.8H96.8z M96.8,111.8L73.3,98.4
			c10.8-11.1,15.3-28.2,16.8-35.2l6.8,3.8v44.8H96.8z M101.3,142.9V117l22.2-12.7l-14.8,34.4L101.3,142.9z M145.2,118l-29.9,17
			l29.9-69.7V118z M145.2,53.9l-18.8,43.5l-25.1,14.4V67l43.8-25v11.9H145.2z M145.2,36.8L99.1,63.1L76.8,50.4
			c2.1-5.1,3.7-10.2,4.3-15L98,45c0.7,0.4,1.6,0.4,2.3,0l45-25.7v17.5H145.2z"
        />
      </g>
    </g>
  </svg>
);

export const _ManageUserAccount = () => (
  <svg
    viewBox="0 0 160 160"
    width={".5em"}
    height={".5em"}
    display={"flex"}
    fill="currentColor"
  >
    <g>
      <g>
        <path
          class="st1"
          d="M66.5,100.4c0,6.8,5.5,12.3,12.2,12.3c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.2-12.3-12.2
			C72,88.2,66.5,93.7,66.5,100.4z M86.2,100.4c0,4.1-3.3,7.5-7.5,7.5c-4.1,0-7.4-3.3-7.4-7.5c0-4.1,3.3-7.4,7.4-7.4
			C82.8,93,86.2,96.4,86.2,100.4z"
        />
      </g>
      <g>
        <path
          class="st1"
          d="M27.7,112.7c6.7,0,12.2-5.5,12.2-12.3s-5.5-12.2-12.2-12.2c-6.8,0-12.3,5.5-12.3,12.2S20.9,112.7,27.7,112.7z
			 M27.7,93c4.1,0,7.4,3.3,7.4,7.4c0,4.1-3.3,7.5-7.4,7.5s-7.5-3.3-7.5-7.5C20.2,96.4,23.6,93,27.7,93z"
        />
      </g>
      <g>
        <path
          class="st1"
          d="M129.8,112.7c6.8,0,12.2-5.5,12.2-12.3s-5.5-12.2-12.2-12.2s-12.2,5.5-12.2,12.2S123,112.7,129.8,112.7z
			 M129.8,93c4.1,0,7.4,3.3,7.4,7.4c0,4.1-3.3,7.5-7.4,7.5c-4.1,0-7.5-3.3-7.5-7.5C122.3,96.4,125.7,93,129.8,93z"
        />
      </g>
      <g>
        <path
          class="st1"
          d="M144.3,116.8h-28.6c-4.7,0-8.8,2.3-11.2,5.9c-2.5-3.6-6.6-5.9-11.2-5.9H64.7c-4.6,0-8.7,2.3-11.2,5.9
			c-2.5-3.6-6.6-5.9-11.2-5.9H13.6c-7.5,0-13.6,6.1-13.6,13.6v25.2c0,1.4,1.1,2.4,2.4,2.4h11.2h28.6h11.2h11.2h28.6h11.2h11.2h28.6
			h11.3c1.3,0,2.4-1.1,2.4-2.4v-25.2C157.9,122.9,151.8,116.8,144.3,116.8z M42.1,129.9c-1.3,0-2.4,1.1-2.4,2.4v20.9H15.9v-20.9
			c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4v20.9H4.7v-22.8c0-4.9,4-8.9,8.9-8.9h28.6c4.9,0,8.9,4,8.9,8.9v22.8h-6.4v-20.9
			C44.6,131.1,43.5,129.9,42.1,129.9z M93.2,129.9c-1.3,0-2.4,1.1-2.4,2.4v20.9H67v-20.9c0-1.3-1.1-2.4-2.4-2.4
			c-1.3,0-2.4,1.1-2.4,2.4v20.9h-6.4v-22.8c0-4.9,3.9-8.9,8.8-8.9h28.6c4.9,0,8.9,4,8.9,8.9v22.8h-6.5v-20.9
			C95.6,131.1,94.5,129.9,93.2,129.9z M153.1,153.2h-6.4v-20.9c0-1.3-1.1-2.4-2.4-2.4c-1.4,0-2.4,1.1-2.4,2.4v20.9h-23.8v-20.9
			c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4v20.9h-6.5v-22.8c0-4.9,4-8.9,8.9-8.9h28.6c4.9,0,8.8,4,8.8,8.9L153.1,153.2
			L153.1,153.2z"
        />
      </g>
      <g>
        <path
          class="st1"
          d="M78.5,25.1c6.9,0,12.5-5.6,12.5-12.5S85.4,0,78.5,0S66,5.7,66,12.6S71.6,25.1,78.5,25.1z M78.5,4.8
			c4.3,0,7.8,3.5,7.8,7.8s-3.5,7.7-7.8,7.7s-7.7-3.5-7.7-7.7S74.2,4.8,78.5,4.8z"
        />
      </g>
      <g>
        <path
          class="st1"
          d="M40.6,69.5h5.8v29.7c0,1.3,1.1,2.4,2.4,2.4s2.4-1.1,2.4-2.4V69.5h1.2H64h29.5h11.6h1.2v29.7
			c0,1.3,1.1,2.4,2.4,2.4c1.3,0,2.4-1.1,2.4-2.4V69.5h6.2c1.3,0,2.4-1,2.4-2.3c0-1.4-1.1-2.4-2.4-2.4h-9.8V43.4c0-7.7-6.3-14-14-14
			H64c-7.7,0-14,6.3-14,14v21.3h-9.4c-1.3,0-2.4,1.1-2.4,2.4C38.2,68.5,39.3,69.5,40.6,69.5z M54.8,43.4c0-5,4.1-9.2,9.2-9.2h12.5
			v26c0,1.3,1.1,2.4,2.4,2.4c1.3,0,2.4-1.1,2.4-2.4v-26h12.2c5.1,0,9.2,4.1,9.2,9.2v21.3h-6.8V45.4c0-1.3-1.1-2.4-2.4-2.4
			c-1.3,0-2.4,1.1-2.4,2.4v19.3H66.4V45.4c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4v19.3h-6.8L54.8,43.4L54.8,43.4z"
        />
      </g>
    </g>
  </svg>
);
